import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isRetail", "isAssignable", "repInfo", "upgradeSource"];
import { formUrl } from 'self-service-api/core/utilities/links';
import { getUserInfo } from 'ui-addon-upgrades/_core/common/api/getUserInfo';
import { submitForm } from 'ui-addon-upgrades/_core/common/api/submitForm';
import { createPqlFormData } from 'ui-addon-upgrades/_core/common/data/pqlData/createPqlFormData';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import wrapWithErrorMonitoring from 'ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring';
import { getPqlFormAttributes } from 'ui-addon-upgrades/_core/pql/getPqlFormAttributes';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { trackPqlFailure } from '../utils/metricUtils';
import { logRavenException } from '../utils/errors';

// to use only when additional PQL information is being submitted. i.e. email or phone number
export const submitAdditionalPqlForm = (pqlData, options = {}) => {
  const formAttributes = getPqlFormAttributes();
  const formEndpoint = formUrl(formAttributes);
  return getUserInfo().then(({
    portal,
    user
  }) => {
    const metaData = {
      timestamp: Date.now()
    };
    const pqlFormData = createPqlFormData({
      metaData,
      pqlData,
      user,
      portal,
      options
    });
    return submitForm(formEndpoint, pqlFormData);
  }).catch(error => {
    logRavenException({
      customMessage: 'Failed to submit additional PQL form',
      error,
      fingerprint: ['submitAdditionalPqlForm']
    });
  });
};
export const submitPql = wrapWithErrorMonitoring('submitPql', pqlData => {
  const {
      isRetail,
      isAssignable,
      repInfo,
      upgradeSource
    } = pqlData,
    upgradeData = _objectWithoutPropertiesLoose(pqlData, _excluded);
  const formAttributes = getPqlFormAttributes();
  const formEndpoint = formUrl(formAttributes);
  return getUserInfo().then(({
    portal,
    user
  }) => {
    const metaData = {
      timestamp: Date.now()
    };
    const pqlFormData = createPqlFormData({
      metaData,
      pqlData,
      user,
      portal
    });
    return submitForm(formEndpoint, pqlFormData);
  }).then(() => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('pqlInteraction', Object.assign({
      action: 'submission succeeded'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      isRetail,
      isAssignable,
      repName: getRepName(repInfo)
    }, upgradeSource && {
      upgradeSource
    }));
  }).catch(error => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('pqlInteraction', Object.assign({
      action: 'submission failed'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      isRetail,
      isAssignable,
      repName: getRepName(repInfo)
    }, upgradeSource && {
      upgradeSource
    }));
    trackPqlFailure(upgradeData.app);
    throw error;
  });
});